module.exports = __webpack_public_path__ + "static/img/3s-info-3.49a2dcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-info-3.png
// module id = ySqE
// module chunks = 0